import React from 'react';
import { TextInput } from '../../../../../components/TextInput';
import { PdfComponentBorderProperties } from '../../../PdfComponent';
import { PdfComponentWithBorder } from '../PdfTemplateComponentBorder';

export default function PdfTemplateComponentBorderWidth({
  component,
  updateBorder,
}: {
  component: PdfComponentWithBorder;
  updateBorder: (border: Partial<PdfComponentBorderProperties>) => void;
}) {
  return (
    <TextInput
      label='Width'
      type='number'
      min={0}
      value={component.border.width}
      onChange={width => updateBorder({ width: Number(width) || 1 })}
    />
  );
}
